import * as React from "react";
const SvgPlayButton = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.2746 9L6 14.25L6 3.75L13.2746 9Z", fill: "currentColor" }));
export default SvgPlayButton;
